import { observer } from 'mobx-react-lite';
import { lazy, Suspense, type ReactNode } from 'react';

import { ACTIVE_HOLIDAY } from '../../config/Environment';
import { Holiday } from './getActiveHoliday';

const Snow = lazy(() => import('./christmas/Snow').then((module) => ({ default: module.Snow })));
const HeartsSnow = lazy(() => import('./valentine/HeartsSnow').then((module) => ({ default: module.HeartsSnow })));
const FallingAutumnLeaves = lazy(() =>
	import('./thanksgiving/FallingAutumnLeaves').then((module) => ({ default: module.FallingAutumnLeaves })),
);
const NyeFireworks = lazy(() => import('./nye/NyeFireworks').then((module) => ({ default: module.NyeFireworks })));
const FourthOfJulyFireworks = lazy(() =>
	import('./fourth-of-july/FourthOfJulyFireworks').then((module) => ({ default: module.FourthOfJulyFireworks })),
);

function getHolidayEffect(holiday: Holiday | null): ReactNode {
	switch (holiday) {
		case Holiday.FourthOfJuly:
			return <FourthOfJulyFireworks />;
		case Holiday.Thanksgiving:
			return <FallingAutumnLeaves />;
		case Holiday.NewYear:
			return <NyeFireworks />;
		case Holiday.Valentine:
			return <HeartsSnow />;
		case Holiday.Christmas:
			return <Snow />;
		case Holiday.Halloween:
		case null:
		default:
			return null;
	}
}

export const HolidayEffect = observer(function HolidayEffect() {
	const activeHolidayEffect = getHolidayEffect(ACTIVE_HOLIDAY);

	if (!activeHolidayEffect) {
		return null;
	}

	return <Suspense {...{ fallback: null }}>{activeHolidayEffect}</Suspense>;
});
